define('app/factories/support_24_7_factory',['app/setup', 'app/views/support_24_7_view'],
    function(takhfifan, support247View) {
        $('.support-24-7').each(function() {
            return new takhfifan.Support247View({
                el: $(this)
            });
        });
    });
